import { render, staticRenderFns } from "./ProfileNotificationForm.vue?vue&type=template&id=417d553c"
import script from "./ProfileNotificationForm.vue?vue&type=script&lang=ts"
export * from "./ProfileNotificationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports